import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const reportDataRequest = {}

reportDataRequest.getReportData = (data) => {
  return axios.post(
    AppUrls.GetReportData,
    Config.SetParameters(data, '', '', ''),
    // Config.ConfigAuth()
  ).then(handleResponse)
}

reportDataRequest.getReports = (data) => {
  return axios.post(
    AppUrls.GetReports,
    Config.SetParameters(data, '', '', ''),
    // Config.ConfigAuth()
  ).then(handleResponse)
}


let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  console.log('respObject',respObject )
  return respObject;
}